/**
 * Singleton object we bind use to bind DOM elements to functions through
 * the viewloader library.
 *
 * snakeCase-named functions are matched to dasher-ize-d DOM nodes:
 *
 *   <div class="foo" data-view-foo-bar="hello">
 *   views.fooBar = function(el, props) {
 *     el.classList.has("foo") // true
 *     props === "hello" // true
 *   }
 *
 * @type {Object}
 */

import adminFileDownload from "../components/admin-file-download";
import allRolePermissions from "../components/roles";
import copyToClipboard from "../components/copy-to-clipboard";
import customFormalist from "../custom-formalist";
import modal from "../components/modal";
import modalForm from "../components/modal-form";
import modalSuccess from "../components/modal-success";
import newsletterFormalist from "../newsletter-formalist";
import navGroup from "../components/nav-group";
import selectChangeUrl from "../components/select-change-url";
import { newsletterExtras } from "../components/newsletter";

const views = {
  adminFileDownload,
  allRolePermissions,
  copyToClipboard,
  customFormalist,
  modal,
  modalForm,
  modalSuccess,
  newsletterFormalist,
  navGroup,
  selectChangeUrl,
  newsletterExtras
};

export default views;
